export default __webpack_public_path__ + "9208de137c05aaa38364fa93d5ebb378.png";